import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import { PathToSubmissionTestIds } from '../PathToSubmission.testIds';

import {
  badgeStyles,
  chipsRowStyles,
  ctaStyles,
  iconColumnStyles,
  rowStyles,
  textColumnStyles,
  titleRowStyles,
} from './SubmissionStepRow.styles';

const SubmissionStepRow = ({ title, subtitle, badge, statusType, cta, chips = [] }) => (
  <Box sx={rowStyles}>
    <Box sx={iconColumnStyles}>
      <StatusIconCDS size={24} type={statusType ?? StatusEnum.IN_PROGRESS} />
    </Box>
    <Box sx={textColumnStyles}>
      <Box sx={titleRowStyles}>
        <Typography variant="medium14">{title}</Typography>
        {badge && (
          <Box sx={badgeStyles}>
            <LabelCDS size="S" title={badge.label} variant={badge.variant} />
          </Box>
        )}
      </Box>
      {subtitle && (
        <Typography color="text.secondary" variant="regular12">
          {subtitle}
        </Typography>
      )}
    </Box>
    {chips.length > 0 && (
      <Box sx={chipsRowStyles}>
        {chips.map(chip => (
          <LabelCDS key={chip.key} size="S" title={chip.title} variant={chip.variant} />
        ))}
      </Box>
    )}
    {cta && (
      <Box sx={ctaStyles}>
        <Button
          data-testid={PathToSubmissionTestIds.SUBMISSION_STEP_ROW_CTA_BUTTON}
          size="small"
          variant="outlined"
          onClick={cta.onClick}
        >
          {cta.label}
        </Button>
      </Box>
    )}
  </Box>
);

SubmissionStepRow.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.shape({
    label: PropTypes.string.isRequired,
    variant: PropTypes.string,
  }),
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      variant: PropTypes.string,
    }),
  ),
  statusType: PropTypes.string,
  subtitle: PropTypes.string,
};

export default SubmissionStepRow;
